/**
 * The crash log's hook (services/api/src/crashlog): tiny on purpose, it is in the main chunk. Window errors, unhandled rejections and
 * the error boundaries call `crash`; the sender (lib/crashReport.ts) loads only when an error happens.
 */
export function crash(e: unknown, app: "web" | "team" = "web"): void {
  void import("./crashReport.ts").then((m) => m.report(e, app), () => {});
}
export function installCrashHook(app: "web" | "team"): void {
  window.addEventListener("error", (e) => crash(e.error ?? e.message, app));
  window.addEventListener("unhandledrejection", (e) => crash(e.reason, app));
}
